export const DISPLAYNAMES_DISPLAYNAME = 1;
export const DISPLAYNAMES_BOTH = 2;
export const DISPLAYNAMES_USERNAME = 3;
